import { createReducer, on } from '@ngrx/store';

import SettingsActions from './actions';
import { SettingsState } from './feature';

export const initialSettingsState = (): SettingsState => ({
  address: undefined,
  companyInfo: undefined,
  soilInfo: undefined,
  appSettings: undefined,
  locations: undefined,
  selectedLocation: undefined,
});

const SettingsReducer = createReducer(
  initialSettingsState(),
  on(SettingsActions.setUserAddress, (state, { address }) => ({
    ...state,
    address,
  })),
  on(SettingsActions.setCompanyInfo, (state, { companyInfo }) => ({
    ...state,
    companyInfo,
  })),
  on(SettingsActions.setSoilInfo, (state, { soilInfo }) => ({
    ...state,
    soilInfo,
  })),
  on(SettingsActions.setAppFocusSettings, (state, { focusSettings }) =>
    state.appSettings
      ? {
          ...state,
          appSettings: {
            ...state.appSettings,
            focusSettings,
          },
        }
      : {
          ...state,
          appSettings: {
            focusSettings,
          },
        },
  ),
  on(
    SettingsActions.finalizeOnboardingSuccess,
    SettingsActions.setSettings,
    (state, { response }) => ({
      ...state,
      address: {
        postalCode: response.postalCode,
        houseNumber: response.houseNumber,
        region: response.region,
      },
      companyInfo: {
        amountOfCows: response.numberOfCows,
        soilType: response.soilType,
      },
      soilInfo: {
        cornHectares: response.maizeHectare,
        grassHectares: response.grassHectare,
      },
      appSettings: {
        ...(state.appSettings ?? {}),
        focusSettings: {
          focusTypes: response.focuses,
          otherFocus: response.otherFocus,
        },
      },
    }),
  ),
  on(SettingsActions.loadUserLocationsSuccess, (state, { response }) => ({
    ...state,
    locations: response,
    ...(state.selectedLocation
      ? { selectedLocation: state.selectedLocation }
      : { selectedLocation: response.length > 0 ? response[0] : undefined }),
  })),
  on(SettingsActions.searchUserLocationsSuccess, (state, { response }) => ({
    ...state,
    locations: response,
  })),
  on(SettingsActions.setLocation, (state, { location }) => ({
    ...state,
    selectedLocation: location,
  })),
);

export default SettingsReducer;
